export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase()).join('') || 'UF';
}

export function place(city?: string | null, country?: string | null, fallback?: string | null): string {
  return [city, country].filter(Boolean).join(', ') || fallback || 'Global';
}

export function timeAgo(value: string): string {
  const ms = Date.now() - new Date(value).getTime();
  const days = Math.max(0, Math.floor(ms / 86_400_000));
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return `${months} ${months === 1 ? 'month' : 'months'} ago`;
}

export function compactNumber(value?: number): string {
  if (!value) return '0';
  return new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(value);
}

export function linkList(value: unknown): Array<{ label: string; url: string }> {
  const safe = (url: string) => {
    try {
      return ['http:', 'https:'].includes(new URL(url).protocol);
    } catch {
      return false;
    }
  };
  if (Array.isArray(value)) {
    return value.filter((item): item is { label: string; url: string } => Boolean(item && typeof item.label === 'string' && typeof item.url === 'string' && safe(item.url)));
  }
  if (value && typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>)
      .filter((entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1].length > 0 && safe(entry[1]))
      .map(([label, url]) => ({ label: label.replaceAll('_', ' '), url }));
  }
  return [];
}

export function externalUrl(value?: string | null): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url.toString() : null;
  } catch {
    return null;
  }
}
